import { render, staticRenderFns } from "./ContractApproval.vue?vue&type=template&id=1635fa43"
import script from "./ContractApproval.vue?vue&type=script&lang=js"
export * from "./ContractApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports